// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getLoginApi } from "../../Service/Api/LoginApi"
import { getErrors, getLoginInfoSuccess } from "../Reducer/LoginReducer"

// Watchers
function* loginInfoSaga() {
	yield takeEvery("login/getLoginInfo", getLoginData)
}

// Sagas
function* getLoginData(action) {
	console.log(action.payload, "saga payload")

	try {
		const loginInfo = yield call(getLoginApi, action.payload)
		console.log(loginInfo, "saga response")

		if (loginInfo.request.status == 200) {

			yield put(getLoginInfoSuccess(loginInfo))

		} else {
			 
			yield put(getErrors(loginInfo))

		}
	} catch (error) {
		
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(loginInfoSaga)])
}
